<template>
  <!-- 処方値修正 -->
  <div id="AppPrescriptionRefSleep">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <div class="columns">
      <div class="column is-full">
        <label class="searchTitle label">処方値参照</label>
      </div>
    </div>

    <div class="columns">
      <div class="column is-full">
        <label class="label">機器情報{{ productIndex + 1 }}</label>
      </div>
    </div>

    <div class="box" style="margin-left: 50px; margin-right: 50px">
      <div style="margin-left: 30px; margin-right: 30px">
        <!-- 詳細表示 -->
        <div style="detailArea">
          <section>
            <div style="height: 10px"></div>

            <table class="table" style="width: 100%">
              <tr style="font-size: 16px">
                <td style="width: 150px">患者コード</td>
                <td>{{ patient.patientCode }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>患者名</td>
                <td>{{ patient.patientName }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>医療機関</td>
                <td>{{ patient.productDetails[productIndex].hospitalName }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>診療科</td>
                <td>{{ patient.productDetails[productIndex].department }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>担当医</td>
                <td>{{ patient.productDetails[productIndex].doctorName }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>品目名</td>
                <td>{{ patient.productDetails[productIndex].productName }}</td>
              </tr>

              <tr style="font-size: 16px">
                <td>シリアル</td>
                <td>{{ patient.productDetails[productIndex].serialNumber }}</td>
              </tr>
            </table>

            <div style="height: 10px"></div>

            <div class="columns header">
              <div class="column is-2" style="text-align: left">No.</div>
              <div
                class="column is-5"
                style="text-align: left; margin-left: 10px"
              >
                項目名
              </div>
              <div
                class="column is-5"
                style="text-align: left; margin-left: 10px"
              >
                処方値
              </div>
            </div>

            <template
              v-for="(settingValue, index) in productDetail.settingValues"
            >
              <!-- 帯 -->
              <heading-comp
                v-if="displaHeading(settingValue)"
                v-bind:key="'heading' + index"
                v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
              ></heading-comp>
              <!-- 項目 -->
              <div class="columns row" v-bind:key="index">
                <div
                  class="column is-2"
                  style="text-align: left; margin-left: 10px"
                >
                  {{ index + 1 }}
                </div>
                <div class="column is-5" style="text-align: left">
                  {{ settingValue.displayName }}
                </div>
                <div
                  v-if="settingValue.itemRule.type === 'char'"
                  class="column is-5"
                  style="text-align: left"
                >
                  {{ getPrescriptionValue(settingValue.settingValue) }}
                  {{
                    isShowUintLabel(
                      settingValue.settingValue,
                      settingValue.itemRule.unit
                    )
                  }}
                </div>
                <div
                  v-else-if="settingValue.itemRule.type === 'sel'"
                  class="column is-5"
                  style="text-align: left"
                >
                  {{
                    getSelectValue(
                      settingValue.itemRule.displayValue,
                      settingValue.settingValue
                    )
                  }}
                  {{
                    isShowUintLabel(
                      settingValue.settingValue,
                      settingValue.itemRule.unit
                    )
                  }}
                </div>
              </div>
            </template>
          </section>
        </div>
      </div>
    </div>

    <!-- 付属品 -->
    <template v-for="(accessory, index) in productDetail.accessories">
      <div :key="'accessoryTitle_' + index" class="columns">
        <div class="column is-full">
          <label class="label">
            機器情報{{ productIndex + 1 }} 付属品　＜
            {{ accessory.type | accessoryFilter }}
            情報＞
          </label>
        </div>
      </div>

      <div
        :key="'accessoryDetail_' + index"
        class="box"
        style="margin-left: 50px; margin-right: 50px"
      >
        <div style="margin-left: 30px; margin-right: 30px">
          <!-- 詳細表示 -->
          <div style="detailArea">
            <section>
              <div style="height: 10px"></div>

              <table class="table" style="width: 100%">
                <tr style="font-size: 16px">
                  <td style="width: 150px">品目コード</td>
                  <td>{{ accessory.itemCode }}</td>
                </tr>

                <tr style="font-size: 16px">
                  <td>品目名</td>
                  <td>{{ accessory.itemName }}</td>
                </tr>

                <tr style="font-size: 16px">
                  <td>シリアル</td>
                  <td>{{ accessory.SERNR }}</td>
                </tr>
              </table>

              <div style="height: 10px"></div>

              <template v-if="accessory.type == accessoryTypes.humidifier.code">
                <div class="columns header">
                  <div class="column is-2" style="text-align: left">No.</div>
                  <div
                    class="column is-5"
                    style="text-align: left; margin-left: 10px"
                  >
                    項目名
                  </div>
                  <div
                    class="column is-5"
                    style="text-align: left; margin-left: 10px"
                  >
                    処方値
                  </div>
                </div>

                <template v-for="(setting, index) in accessory.settings">
                  <div class="columns row" v-bind:key="index">
                    <div
                      class="column is-2"
                      style="text-align: left; margin-left: 10px"
                    >
                      {{ index + 1 }}
                    </div>
                    <div class="column is-5" style="text-align: left">
                      {{ setting.displayName }}
                    </div>
                    <div
                      v-if="setting.itemRule.type === 'char'"
                      class="column is-5"
                      style="text-align: left"
                    >
                      {{ getPrescriptionValue(setting.value) }}
                      {{ isShowUintLabel(setting.value, setting.unit) }}
                    </div>
                    <div
                      v-else-if="setting.itemRule.type === 'sel'"
                      class="column is-5"
                      style="text-align: left"
                    >
                      {{
                        getSelectValue(
                          setting.itemRule.displayValue,
                          setting.value
                        )
                      }}
                      {{
                        isShowUintLabel(setting.value, setting.itemRule.unit)
                      }}
                    </div>
                  </div>
                </template>
              </template>
            </section>
          </div>
        </div>
      </div>
    </template>

    <!-- 下部余白 -->
    <div style="height: 10px" />

    <!-- 戻るボタン -->
    <div style="text-align: center">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
        >戻る</b-button
      >
    </div>
  </div>
</template>

<script>
import * as item from "../utils/item";

const HeadingCompTemplate = {
  props: ["index", "color", "value1", "value2", "value3", "textStyle"],
  template: `
  <div class="columns row" :style="color">
      <div class="column is-1" style="text-align:left; margin-left:10px;"/>
      <div class="column is-3" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value1}}</span>
      </div>
      <div class="column is-2" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value2}}</span>
      </div>
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;"/>
      <div class="column" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value3}}</span>
      </div>
  </div>
  `,
  data: function () {
    return {};
  },
  created: function () {},
  methods: {},
};

export default {
  name: "AppPrescriptionRefSleep",
  methods: {
    displaHeading: function (item) {
      let isDisplay = false;
      switch (item.reportFormatType) {
        case this.MACHINE_TYPE_ASV:
          // ASV
          if (
            item.displayName == "加湿器" ||
            item.displayName == "マスクの種類" ||
            item.displayName == "通信モジュール" ||
            item.displayName == "電源コード"
          ) {
            isDisplay = true;
          }
          break;
        case this.MACHINE_TYPE_CPAP:
        case this.MACHINE_TYPE_SBOX:
        case this.MACHINE_TYPE_PRISMA:
          // CPAP,SBOX,prisma
          if (
            item.displayName == "加温加湿器" ||
            item.displayName == "通信モジュール" ||
            item.displayName == "マスク：種類"
          ) {
            isDisplay = true;
          }
          break;
      }

      return isDisplay;
    },

    back: function () {
      this.$router.push({
        name: "AppPatientDetailSleep",
        params: {
          code: this.patient.patientCode,
          searchConditions: this.searchConditions,
        },
      });
      return;
    },

    getPrescriptionValue(value) {
      if (value == "-" || value == "null" || !value) {
        return "";
      } else {
        return value;
      }
    },

    getSelectValue(displayValue, settingValue) {
      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key == settingValue) {
          value = displayValue[i].value;
        }
      }
      return value;
    },

    isShowUintLabel(value, unit) {
      let ret = "";
      if (value && value != "-") {
        ret = unit;
      }
      return ret;
    },

    loadData: function () {
      // 処方値取得
      this.apiCall(
        this.getMachineValue,
        this.getMachineValueSuccess,
        this.showErrorMessage,
        this.$store.state.subSystem
      );
      return;
    },

    getMachineValue: function (client) {
      // 処方値取得
      const productDetail =
        this.$route.params.patient.productDetails[this.productIndex];

      const res = client.apis.apiPatient.getMachineValueGET({
        kanjaDotaiKeyId: productDetail.kanjaDotaiKeyId,
      });

      return res;
    },

    getMachineValueSuccess: function (result) {
      // 処方値取得結果設定
      this.productDetail = result.obj;
      return;
    },
  },

  data() {
    const productIndex = this.$route.params.productIndex;
    const MACHINE_TYPE_ASV = 13;
    const MACHINE_TYPE_CPAP = 14;
    const MACHINE_TYPE_SBOX = 15;
    const MACHINE_TYPE_PRISMA = 16;

    return {
      productIndex: productIndex,
      patient: this.$route.params.patient,
      productDetail: {
        settingValues: [],
        accessories: [],
      },
      searchConditions: this.$route.params.searchConditions,
      accessoryTypes: item.ACCESSORY_TYPE_MAP,
      MACHINE_TYPE_ASV,
      MACHINE_TYPE_CPAP,
      MACHINE_TYPE_SBOX,
      MACHINE_TYPE_PRISMA,
    };
  },
  components: {
    "heading-comp": HeadingCompTemplate,
  },
  mounted: function () {},
  created: function () {
    this.loadData();
    return;
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: double;
}
.row {
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPrescriptionRefSleep.vue